import React, { Component } from 'react';
import { getString } from 'utils/translate';

export default class Deprecated extends Component {
  render() {
    const DEPRECATED_ICON = (
      <img
        src={require('images/error_DB2B1C.svg')}
        width={18}
        height={18}
        title={getString('label.deprecated')}
      />
    );
    return <div>{DEPRECATED_ICON}</div>;
  }
}
